module.exports = __webpack_public_path__ + "img/bonus_symbol_2.423a3e31.png";